export async function onboardingGet(action = "config") {
  const response = await fetch(`/api/onboarding.php?action=${action}`, { credentials: "include", cache: "no-store" });
  const data = await response.json();
  if (!response.ok || !data.ok) throw new Error(data.error || "Impossibile caricare i dati. Riprova tra poco.");
  return data;
}

export async function onboardingPost(action, values, csrf) {
  const response = await fetch("/api/onboarding.php", {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json", "X-Norma-CSRF": csrf },
    body: JSON.stringify({ ...values, action }),
  });
  const data = await response.json();
  if (!response.ok || !data.ok) throw new Error(data.error || "Operazione non riuscita. Riprova tra poco.");
  return data;
}

export function checkoutRedirect(url) {
  const target = new URL(url, window.location.origin);
  if (target.origin !== window.location.origin && !(target.protocol === "https:" && ["checkout.stripe.com", "billing.stripe.com"].includes(target.hostname))) {
    throw new Error("Indirizzo di pagamento non valido.");
  }
  window.location.assign(target.href);
}
